module.exports = __webpack_public_path__ + "img/loading3.3e76ee81.gif";